var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink, } from '@react-pdf/renderer';
import { formatNumber } from '../../services/utils/utils';
import { Button } from '../../utils/Button';
import { ExportIcon } from '../../utils/Icons';
import moment from 'moment';
import { getOriginalUser } from '../../services/utilisateur';
import { Stack } from '@mui/material';
import { getInfos } from '../../services/affaire';
import { useEffect, useState } from 'react';
import { Loader } from '../../utils/Loader';
var originalUser = getOriginalUser();
var COLOR = '#062131';
var BORDER_COLOR = '#062131';
var BORDER_STYLE = 'solid';
var BORDER_WIDTH_TABLE = 1;
var COL1_WIDTH = 10;
var COLN_WIDTH = (100 - COL1_WIDTH) / (originalUser.Licence.UseTva ? 6 : 5);
var COL_LIBELLE_WIDTH = COLN_WIDTH * (originalUser.Licence.UseTva ? 2 : 2.8);
var SMALL = 5;
var MEDIUM = 10;
var LARGE = 15;
var styles = StyleSheet.create({
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        padding: SMALL,
    },
    titre: {
        fontSize: 15,
        fontFamily: 'Helvetica-Bold',
        width: '100%',
        textAlign: 'center',
        paddingBottom: MEDIUM,
    },
    bold: {
        fontFamily: 'Helvetica-Bold',
    },
    row: {
        width: 'auto',
        marginBottom: '1',
        marginTop: '1',
        flexDirection: 'row',
    },
    simpleRow: {
        width: 'auto',
        margin: '0',
        flexDirection: 'row',
    },
    right: {
        textAlign: 'right',
    },
    logo: {
        height: '80px',
        width: '80px',
    },
    width50: {
        width: '50%',
    },
    colSm50: {
        width: '50%',
        position: 'relative',
        minHeight: '1px',
    },
    table: {
        width: 'auto',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        paddingTop: '15px',
    },
    tableRow: {
        margin: 'auto',
        flexDirection: 'row',
    },
    rowTotal: {
        fontSize: 15,
        fontFamily: 'Helvetica-Bold',
        borderWidth: 1,
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        paddingBottom: '15px',
        paddingTop: '15px',
    },
    tableCol1Header: {
        width: COL1_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH_TABLE,
        borderLeftWidth: 0,
        borderRightWidth: 0,
    },
    tableColHeaderLibelle: {
        width: COL_LIBELLE_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH_TABLE,
        borderLeftWidth: 0,
        borderRightWidth: 0,
    },
    tableColHeaderRight: {
        width: COLN_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH_TABLE,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        textAlign: 'right',
    },
    tableCol1: {
        width: COL1_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableColLibelle: {
        width: COL_LIBELLE_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCol: {
        width: COLN_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableColRight: {
        width: COLN_WIDTH + '%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        textAlign: 'right',
    },
    tableCellHeader: {
        margin: 5,
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
    },
    tableCell: {
        margin: 5,
        fontSize: 7,
    },
    tableCellT1: {
        marginTop: 5,
        marginBottom: 5,
    },
    cadreEnveloppe: {
        border: 1,
        borderColor: 'grey',
        marginTop: 15,
        padding: 5,
    },
});
var displayKeyValue = function (key, value) {
    if (!value) {
        return;
    }
    return (_jsxs(View, __assign({ style: styles.row }, { children: [_jsxs(Text, __assign({ style: styles.bold }, { children: [key, " :"] })), _jsx(Text, __assign({ style: { marginLeft: 3 } }, { children: value }))] })));
};
var displayAdresse = function (_a) {
    var Titre = _a.Titre, Adresse = _a.Adresse, CodePostal = _a.CodePostal, Ville = _a.Ville, _b = _a.Pays, Pays = _b === void 0 ? null : _b;
    return (_jsxs(View, { children: [_jsx(Text, __assign({ style: styles.bold }, { children: Titre })), _jsxs(View, __assign({ style: { marginTop: SMALL } }, { children: [_jsx(Text, { children: Adresse }), _jsxs(Text, { children: [CodePostal, " ", Ville] }), Pays ? _jsx(Text, { children: Pays }) : _jsx(_Fragment, {})] }))] }));
};
var DocumentPdf = function (infos) {
    return (_jsx(_Fragment, { children: _jsx(Document, { children: _jsxs(Page, __assign({ size: "A4", style: {
                    fontFamily: 'Helvetica',
                    padding: LARGE * 2,
                    fontSize: 8,
                    color: COLOR,
                    paddingBottom: 50,
                } }, { children: [_jsx(View, __assign({ style: {
                            paddingTop: MEDIUM,
                            marginBottom: LARGE,
                        }, fixed: false }, { children: _jsxs(View, __assign({ style: styles.row }, { children: [_jsxs(View, __assign({ style: styles.colSm50 }, { children: [displayAdresse({
                                            Titre: infos.Emetteur.FullName,
                                            Adresse: infos.Emetteur.Adresse,
                                            CodePostal: infos.Emetteur.CodePostal,
                                            Ville: infos.Emetteur.Ville,
                                            Pays: infos.Emetteur.Pays,
                                        }), infos.Emetteur.Telephone || infos.Emetteur.Email ? (_jsxs(View, __assign({ style: { marginTop: SMALL } }, { children: [infos.Emetteur.Telephone ? (_jsx(Text, { children: infos.Emetteur.Telephone })) : (_jsx(_Fragment, {})), infos.Emetteur.Email ? (_jsx(Text, { children: infos.Emetteur.Email })) : (_jsx(_Fragment, {}))] }))) : (_jsx(_Fragment, {})), infos.Emetteur.Siret ? (_jsx(View, __assign({ style: { marginTop: SMALL } }, { children: displayKeyValue('Siret', infos.Emetteur.Siret) }))) : (_jsx(_Fragment, {})), _jsx(View, __assign({ style: { marginTop: SMALL } }, { children: displayKeyValue('Réf', infos.Numero) }))] })), _jsxs(View, __assign({ style: styles.colSm50 }, { children: [_jsxs(Text, __assign({ style: { textAlign: 'right' } }, { children: ["Le ", moment(infos.Date).format('DD/MM/YYYY')] })), _jsxs(View, __assign({ style: styles.cadreEnveloppe }, { children: [_jsx(View, __assign({ style: { marginBottom: SMALL } }, { children: displayAdresse({
                                                        Titre: infos.NomRecepteur,
                                                        Adresse: infos.client.Adresse,
                                                        CodePostal: infos.client.CodePostal,
                                                        Ville: infos.client.Ville,
                                                    }) })), displayKeyValue('Siret', infos.client.IsSociete ? infos.client.Siret : null), displayKeyValue('Tel.', infos.client.IsSociete ? null : infos.client.Telephone), displayKeyValue('Mob.', infos.client.IsSociete ? null : infos.client.Mobile)] }))] }))] })) })), _jsxs(View, __assign({ style: {
                            marginBottom: LARGE,
                        } }, { children: [_jsx(Text, __assign({ style: styles.titre }, { children: infos.Titre })), _jsx(View, __assign({ style: styles.rowTotal }, { children: _jsxs(View, __assign({ style: styles.simpleRow }, { children: [_jsx(View, __assign({ style: styles.width50 }, { children: _jsx(Text, __assign({ style: { marginLeft: SMALL } }, { children: originalUser.Licence.UseTva
                                                    ? 'Montant total TTC'
                                                    : 'Montant total' })) })), _jsx(View, __assign({ style: styles.width50 }, { children: _jsx(Text, __assign({ style: styles.right }, { children: formatNumber(originalUser.Licence.UseTva
                                                    ? infos.TotalTTC
                                                    : infos.TotalTarif, '€') })) }))] })) })), infos.Details ? (_jsx(View, __assign({ style: __assign(__assign({}, styles.row), { marginTop: MEDIUM }) }, { children: _jsx(Text, { children: infos.Details }) }))) : (_jsx(_Fragment, {})), _jsxs(View, __assign({ style: styles.table }, { children: [_jsxs(View, __assign({ fixed: true, style: styles.tableRow }, { children: [_jsx(View, __assign({ style: styles.tableColHeaderLibelle }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "D\u00E9signation" })) })), _jsx(View, __assign({ style: styles.tableCol1Header }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "Quantit\u00E9" })) })), _jsx(View, __assign({ style: styles.tableColHeaderRight }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "Prix unitaire" })) })), _jsx(View, __assign({ style: styles.tableColHeaderRight }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: originalUser.Licence.UseTva ? 'Montant HT' : 'Montant' })) })), originalUser.Licence.UseTva ? (_jsxs(_Fragment, { children: [_jsx(View, __assign({ style: __assign(__assign({}, styles.tableCol1Header), styles.right) }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "TVA" })) })), _jsx(View, __assign({ style: styles.tableColHeaderRight }, { children: _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "Montant TTC" })) }))] })) : (_jsx(_Fragment, {}))] })), infos.offres ? (infos.offres
                                        .sort(function (a, b) {
                                        return (a.Ordre ? a.Ordre : 0) - (b.Ordre ? b.Ordre : 0);
                                    })
                                        .map(function (o) {
                                        return (_jsxs(View, __assign({ style: styles.tableRow }, { children: [_jsx(View, __assign({ style: styles.tableColLibelle }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.Designation })) })), _jsx(View, __assign({ style: styles.tableCol1 }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.WithQuantite ? (_jsxs(_Fragment, { children: [formatNumber(o.Quantite), o.Unite ? ' ' + o.Unite : ''] })) : ('-') })) })), _jsx(View, __assign({ style: styles.tableColRight }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.WithQuantite && o.Tarif !== 0
                                                            ? formatNumber(o.Tarif, '€')
                                                            : '-' })) })), _jsx(View, __assign({ style: styles.tableColRight }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.TotalTarif !== 0
                                                            ? formatNumber(o.TotalTarif, '€')
                                                            : '-' })) })), originalUser.Licence.UseTva ? (_jsxs(_Fragment, { children: [_jsx(View, __assign({ style: __assign(__assign({}, styles.tableCol1), styles.right) }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.Tva !== 0
                                                                    ? formatNumber(o.Tva * 100, '%')
                                                                    : '-' })) })), _jsx(View, __assign({ style: styles.tableColRight }, { children: _jsx(Text, __assign({ style: styles.tableCell }, { children: o.TotalTTC !== 0
                                                                    ? formatNumber(o.TotalTTC, '€')
                                                                    : '-' })) }))] })) : (_jsx(_Fragment, {}))] }), o.IdOffre));
                                    })) : (_jsx(_Fragment, {})), originalUser.Licence.UseTva ||
                                        Object.keys(infos.DetailsTotaux).length ? (_jsxs(View, __assign({ style: __assign(__assign({}, styles.tableRow), { marginTop: MEDIUM }) }, { children: [_jsx(View, __assign({ style: __assign({ width: COL_LIBELLE_WIDTH -
                                                        COL1_WIDTH +
                                                        COLN_WIDTH * (originalUser.Licence.UseTva ? 4 : 2) +
                                                        '%' }, styles.right) }, { children: _jsxs(View, __assign({ style: { textAlign: 'right' } }, { children: [Object.keys(infos.DetailsTotaux).map(function (detailLibelle) { return (_jsxs(Text, __assign({ style: __assign(__assign({}, styles.tableCell), styles.bold) }, { children: ["Total ", detailLibelle.toLowerCase()] }), detailLibelle)); }), originalUser.Licence.UseTva ? (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "Total HT" })), _jsx(Text, __assign({ style: styles.tableCellHeader }, { children: "Total TVA" }))] })) : (_jsx(_Fragment, {}))] })) })), _jsxs(View, __assign({ style: styles.tableColRight }, { children: [Object.keys(infos.DetailsTotaux).map(function (detailKey) { return (_jsx(Text, __assign({ style: __assign(__assign({}, styles.tableCellT1), styles.bold) }, { children: formatNumber(infos.DetailsTotaux[detailKey], '€') }), detailKey)); }), originalUser.Licence.UseTva ? (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ style: __assign(__assign({}, styles.tableCellT1), styles.bold) }, { children: formatNumber(infos.TotalTarif, '€') })), _jsx(Text, __assign({ style: __assign(__assign({}, styles.tableCellT1), styles.bold) }, { children: formatNumber(infos.TotalTVA, '€') }))] })) : (_jsx(_Fragment, {}))] }))] }))) : (_jsx(_Fragment, {}))] }))] })), infos.Paragraphe ? (_jsx(View, __assign({ break: true }, { children: _jsx(View, __assign({ style: __assign(__assign({}, styles.row), { marginTop: SMALL }) }, { children: _jsx(Text, { children: infos.Paragraphe }) })) }))) : (_jsx(_Fragment, {})), _jsx(Text, { fixed: true, style: __assign(__assign({}, styles.footer), { textAlign: 'center', color: 'grey' }), render: function (_a) {
                            var pageNumber = _a.pageNumber, totalPages = _a.totalPages;
                            return "".concat(pageNumber, " / ").concat(totalPages);
                        } })] })) }) }));
};
export var GenerateurDevis = function (_a) {
    var AffaireId = _a.AffaireId, _b = _a.forceInfos, forceInfos = _b === void 0 ? {} : _b;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), devis = _d[0], setDevis = _d[1];
    useEffect(function () {
        var getDatas = function () { return __awaiter(void 0, void 0, void 0, function () {
            var infos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getInfos(AffaireId)];
                    case 1:
                        infos = (_a.sent()).infos;
                        setDevis(__assign(__assign({}, infos), forceInfos));
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getDatas();
    }, [AffaireId, forceInfos]);
    if (loading) {
        return _jsx(Loader, {});
    }
    return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(PDFDownloadLink, __assign({ className: "mb-small", document: DocumentPdf(devis), fileName: "".concat(devis.Titre, "_").concat(devis.Numero, ".pdf") }, { children: function (_a) {
                    var blob = _a.blob, url = _a.url, loading = _a.loading, error = _a.error;
                    return (_jsx(Button, __assign({ startIcon: _jsx(ExportIcon, {}) }, { children: "T\u00E9l\u00E9charger" })));
                } })), _jsx(PDFViewer, __assign({ style: { minHeight: '600px', height: '100%', width: '100%' } }, { children: DocumentPdf(devis) }))] })));
};
//# sourceMappingURL=GenerateurDevis.js.map